import { Box, Divider, Grid, IconButton, Modal, Typography } from '@mui/material';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import CloseIcon from '@mui/icons-material/Close';
import FacebookIcon from '@mui/icons-material/Facebook';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LinkIcon from '@mui/icons-material/Link';

import ContactModalStats from './ContactModalStats';
function ContactModal(props) {
  const style = {
    position: 'absolute',
    top: '14%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
    boxShadow: 24,
    p: 2,
    width: '550px',
    borderRadius: '5px',
  };

  return (
    <Modal
      open={props.open}
      // onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Grid container>
          <Grid item md={12} width={'100%'} textAlign={'end'}>
            <IconButton onClick={() => props.close(false)} style={{ textAlign: 'end' }}>
              <CloseIcon></CloseIcon>
            </IconButton>
          </Grid>
          <Grid item md={12}>
            <Grid container justifyContent={'start'}>
              <Grid item md={5}>
                <Grid container>
                  <Grid item md={11}>
                    <Grid container direction={'column'}>
                      <Grid item width="100%" textAlign={'center'}>
                        <Typography
                          style={{ fontSize: '25px', fontWeight: '600', color: '#febd1c' }}
                        >
                          Contact details
                        </Typography>
                      </Grid>
                      {props.contact.length > 0 ||
                      props.email.length > 0 ||
                      props.whatsapp.length > 0 ? (
                        <Grid container direction={'column'}>
                          {props.contact.length > 0 ? (
                            <Grid item style={{ marginTop: '25px' }}>
                              <ContactModalStats
                                icon={LocalPhoneIcon}
                                heading={'Phone'}
                                data={props.contact.map((data) => data)}
                                open={'no'}
                              ></ContactModalStats>
                            </Grid>
                          ) : (
                            ''
                          )}
                          {props.email.length > 0 ? (
                            <Grid item style={{ marginTop: '15px' }}>
                              <ContactModalStats
                                icon={EmailIcon}
                                heading={'Email'}
                                data={props.email.map((data) => data)}
                                open={'no'}
                              ></ContactModalStats>
                            </Grid>
                          ) : (
                            ''
                          )}
                          {props.whatsapp.length > 0 ? (
                            <Grid item style={{ marginTop: '15px' }}>
                              <ContactModalStats
                                icon={WhatsAppIcon}
                                heading={'whatsapp'}
                                data={props.whatsapp.map((data) => data)}
                                open={'no'}
                              ></ContactModalStats>
                            </Grid>
                          ) : (
                            ''
                          )}
                        </Grid>
                      ) : (
                        <Grid
                          item
                          width={'100%'}
                          height={'100%'}
                          alignSelf={'center'}
                          textAlign={'center'}
                        >
                          <Typography style={{ marginTop: '40px' }}>No data available</Typography>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item md={1} width={'100%'} textAlign={'center'}>
                <Divider
                  orientation="vertical"
                  style={{ width: '1px', height: '100%', marginLeft: '20px' }}
                />
              </Grid>

              <Grid item md={6}>
                <Grid container direction={'row'}>
                  <Grid item md={11}>
                    <Grid container style={{ marginLeft: '10px' }}>
                      <Grid item width={'100%'} textAlign={'center'}>
                        <Typography
                          style={{ fontSize: '25px', fontWeight: '600', color: '#febd1c' }}
                        >
                          Other accounts
                        </Typography>
                      </Grid>
                      <Grid item width={'100%'}>
                        {props.insta.length ||
                        props.yt.length > 0 ||
                        props.thread.length > 0 ||
                        props.twitter.length > 0 ||
                        props.facebook.length > 0 ||
                        props.whatsapp.length ||
                        (props.socialLinks && props.socialLinks.length > 0) ? (
                          <Grid container direction={'column'}>
                            {props.socialLinks && props.socialLinks.length > 0 ? (
                              <Grid item md={12} style={{ marginTop: '25px' }}>
                                <ContactModalStats
                                  icon={LinkIcon}
                                  heading={'Social links'}
                                  data={props.socialLinks
                                    .map((x) => x?.socialSite || x?.url || x?.link)
                                    .filter(Boolean)}
                                  open={'yes'}
                                ></ContactModalStats>
                              </Grid>
                            ) : (
                              ''
                            )}
                            {props.insta.length > 0 ? (
                              <Grid item md={12} style={{ marginTop: '25px' }}>
                                <ContactModalStats
                                  icon={InstagramIcon}
                                  heading={'Instagram'}
                                  data={props.insta.map((data) => data)}
                                  open={'yes'}
                                ></ContactModalStats>
                              </Grid>
                            ) : (
                              ''
                            )}
                            {props.yt.length > 0 ? (
                              <Grid item style={{ marginTop: '15px' }}>
                                <ContactModalStats
                                  icon={YouTubeIcon}
                                  heading={'Youtube'}
                                  data={props.yt.map((data) => data)}
                                  open={'yes'}
                                ></ContactModalStats>
                              </Grid>
                            ) : (
                              ''
                            )}
                            {props.thread.length > 0 ? (
                              <Grid item style={{ marginTop: '15px' }}>
                                <ContactModalStats
                                  icon={LinkedInIcon}
                                  heading={'Thread'}
                                  data={props.thread.map((data) => data)}
                                  open={'yes'}
                                ></ContactModalStats>
                              </Grid>
                            ) : (
                              ''
                            )}
                            {props.twitter.length > 0 ? (
                              <Grid item style={{ marginTop: '15px' }}>
                                <ContactModalStats
                                  icon={TwitterIcon}
                                  heading={'Twittter'}
                                  data={props.twitter.map((data) => data)}
                                  open={'yes'}
                                ></ContactModalStats>
                              </Grid>
                            ) : (
                              ''
                            )}
                            {props.facebook.length > 0 ? (
                              <Grid item style={{ marginTop: '15px' }}>
                                <ContactModalStats
                                  icon={FacebookIcon}
                                  heading={'facebook'}
                                  data={props.facebook.map((data) => data)}
                                  open={'yes'}
                                ></ContactModalStats>
                              </Grid>
                            ) : (
                              ''
                            )}
                          </Grid>
                        ) : (
                          <Grid item width={'100%'} textAlign={'center'}>
                            <Typography style={{ marginTop: '50px' }}>No data available</Typography>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item md={12} style={{ marginTop: '35px' }}></Grid>
        </Grid>
      </Box>
    </Modal>
  );
}

export default ContactModal;
